module.exports = __webpack_public_path__ + "img/hyper.fd5f1a67.png";